import { ProjectInvitationWithProjectDTO } from "../dtos/project-invitation.dto";

interface ProjectInvitationWithProject {
  id: string;
  project_id: string;
  email: string;
  role: string;
  invited_by_id: string;
  status: string;
  expires_at: string;
  created_at: string;
  accepted_at: string | null;
  token: string;
  project: {
    id: string;
    name: string;
    description: string | null;
  };
}

export class ProjectInvitationMapper {
  static toProjectInvitationWithProjectDTO(data: ProjectInvitationWithProject): ProjectInvitationWithProjectDTO {
    return {
      id: data.id,
      projectId: data.project_id,
      email: data.email,
      role: data.role as any,
      invitedById: data.invited_by_id,
      status: data.status as any,
      token: data.token,
      expiresAt: new Date(data.expires_at),
      createdAt: new Date(data.created_at),
      acceptedAt: data.accepted_at ? new Date(data.accepted_at) : null,
      project: {
        id: data.project.id,
        name: data.project.name,
        description: data.project.description,
      },
    };
  }
}